import { BillingContact } from './BillingContact/BillingContact';
import type { ContactsSection } from './Contacts.types';
import { ExtranetContacts } from './ExtranetContacts/ExtranetContacts';
import { GuestRelationContact } from './GuestRelationContact/GuestRelationContact';
import { PrincipalContact } from './PrincipalContact/PrincipalContact';
import { SpacesContacts } from './SpacesContacts/SpacesContacts';

export const CONTACTS_SECTIONS: ContactsSection[] = [
  {
    key: 'principal-contact',
    title: 'Principal contact for Staycation',
    subtitle:
      'Person in charge of the partnership (1 person) - will only be contacted for specific strategic issues',
    component: PrincipalContact,
  },
  {
    key: 'extranet-contacts',
    title: 'Contact(s) having access to extranet and managing inventory',
    subtitle:
      'Person(s) having access to the extranet and receiving communications according to setup (minimum 1 person)',
    component: ExtranetContacts,
  },
  {
    key: 'space-contacts',
    title: 'Contact(s) for Hotel Spaces',
    subtitle:
      'Person(s) who will receive booking confirmations for their assigned space - these contacts will not have access to the extranet.',
    component: SpacesContacts,
  },
  {
    key: 'guest-relation-contact',
    title: 'Contact for Guest Relations',
    subtitle:
      'Person(s) to contact for specific demands related to customer stays',
    component: GuestRelationContact,
  },
  {
    key: 'billing-contact',
    title: 'Contact for billing',
    subtitle: 'Person(s) who will receive the invoices (1 person or more)',
    component: BillingContact,
  },
];
